var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBarGraph = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 99 75",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bar Graph")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keynote-Slide",
    transform: "translate(-1322.000000, -429.000000)",
    fill: "#F5F5F5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1353.07147,466.285678 L1353.07147,490.857136 L1340.78574,490.857136 L1340.78574,466.285678 L1353.07147,466.285678 Z M1371.50006,441.71422 L1371.50006,490.857136 L1359.21433,490.857136 L1359.21433,441.71422 L1371.50006,441.71422 Z M1420.64297,497 L1420.64297,503.142864 L1322.35714,503.142864 L1322.35714,429.428491 L1328.50001,429.428491 L1328.50001,497 L1420.64297,497 Z M1389.92865,453.999949 L1389.92865,490.857136 L1377.64292,490.857136 L1377.64292,453.999949 L1389.92865,453.999949 Z M1408.35725,435.571355 L1408.35725,490.857136 L1396.07152,490.857136 L1396.07152,435.571355 L1408.35725,435.571355 Z",
    id: "Bar-Graph"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarGraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bar Graph.35d6c5ba.svg";
export { ForwardRef as ReactComponent };